import React from "react";
import dayjs from "dayjs";
import {
  StyleSheet,
  Text,
  TouchableNativeFeedback,
  View,
  TouchableOpacity,
  Image,
} from "react-native";
import {
  CrateV2,
  Delivered,
  Order,
  PacketsV2,
  CustomersV2,
  ItemsV2,
} from "@assets/svg/MyDeliveries";
import RightArrow from "@assets/svg/RightArrow";
import Rupees from "@assets/svg/RupeesIcon";
import CustomText from "@components/CustomText";
import { MY_DELIVERY_EVENTS } from "@constants/analyticsEventsCT";
import color from "@constants/color";
import t from "@constants/localization";
import { colors } from "@constants/theme";
import { useNavigation } from "@react-navigation/native";
import analytics from "@services/analytics";
import { fontFamily } from "@utils/styles";
import Info from "@assets/svg/MyDeliveries/Info";
import { useSelector } from "react-redux";
import {
  getCrateListFromCrateIds,
  getUnableToDeliverText,
} from "../DeliveryReturn/utils";
import CratePacketItemsInfo from "../components/CratePacketItemsInfo";
import HandoverVideoStrip from "../DeliveryReturn/HandoverVideoStrip";

const PATH = "screens/MyDeliveries/DeliveryReturn/OverView";
const DELIVERY_PATH = "screens/MyDeliveries/DeliveryReturn/DeliveryCard";

function DeliveryCard({
  deliveryDetails,
  setInfoTooltipVisible,
  setInfoTooltipData,
}) {
  const navigation = useNavigation();
  const {
    state,
    noOfCrates,
    crates_list,
    noOfShipments,
    noOfOpenItems,
    noOfUsers,
    noOfCdcBags,
    date,
    spokeName,
    totalPayableAmount,
    user_shipments_list,
    user_open_items_list,
  } = deliveryDetails;
  const { isSortingEnabled = false, features = {} } = useSelector(
    ({ configReducer }) => configReducer,
  );
  const isCpDb = useSelector(({ auth }) => auth?.user?.cp_db_id);
  const Content = [
    {
      field: "crate",
      icon: <CrateV2 />,
      text: t(`${PATH}/crate`),
      value: noOfCrates || 0,
      list: noOfCrates ? getCrateListFromCrateIds(crates_list) : [],
    },
    {
      field: "packets",
      icon: <PacketsV2 />,
      text: t(`${PATH}/packets`),
      value: noOfShipments || 0,
      list: noOfShipments ? user_shipments_list : [],
    },
    {
      field: "hwi",
      icon: <ItemsV2 />,
      text: t(`${PATH}/items`),
      value: noOfOpenItems || 0,
      list: noOfOpenItems ? user_open_items_list : [],
    },
    {
      field: "customer",
      icon: <CustomersV2 />,
      text: t(`${PATH}/customers`),
      value: noOfUsers,
    },
    {
      field: "bags",
      icon: <PacketsV2 />,
      text: t(`${PATH}/bags`),
      value: deliveryDetails?.noOfCdcBags || 0,
      list: deliveryDetails?.noOfCdcBags ? deliveryDetails.cdc_bags_list : [],
    },
  ];

  const handleNotDeliveredPress = () => {
    navigation.navigate("DeliveryOrdersList", {
      date: date || dayjs().format("YYYY-MM-DD"),
      tab: "Current day",
      forNotDelivered: true,
    });

    analytics.trackEvent(MY_DELIVERY_EVENTS.VIEW_DETAILS_CLICKED, {
      screen: "Delivery Page",
      tab: "Current day",
      section: "Deliveries",
      forNotDelivered: true,
    });
  };

  const handlePressViewDetails = () => {
    navigation.navigate(
      noOfCrates > 0 || noOfOpenItems > 0 || noOfCdcBags > 0
        ? isSortingEnabled
          ? "SortingDeliveries"
          : "DeliveryOrdersCrateList"
        : "DeliveryOrdersList",
      {
        date,
        spokeName,
        tab: "PREVIOUS_DAYS",
        type: "ASSIGNED",
      },
    );
    analytics.trackEvent(MY_DELIVERY_EVENTS.VIEW_DETAILS_CLICKED, {
      screen: "MY_DELIVERIES",
      tab: "PREVIOUS_DAYS",
      section: "DELIVERY",
    });
  };

  const onPressInfo = (data) => {
    setInfoTooltipVisible(true);
    setInfoTooltipData(data);
  };

  return (
    <View style={styles.cardContainer}>
      <View style={styles.card}>
        <View
          style={[
            styles.headerContainer,
            {
              backgroundColor:
                state === "Delivery"
                  ? "rgba(0, 171, 89, 0.04)"
                  : "rgba(0, 0, 0, 0.04)",
            },
          ]}
        >
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Delivered status={state} />
            <Text
              style={
                state === "Delivery"
                  ? styles.greenHeaderText
                  : styles.greyHeaderText
              }
            >
              {t(`${PATH}/${state}`)}
            </Text>
          </View>
        </View>
        {isCpDb ? null : <HandoverVideoStrip date={date} />}
        {true ? (
          <View>
            {deliveryDetails?.usersUnableToDeliver ? (
              <TouchableOpacity
                testID="handleNotDeliveredPress"
                onPress={handleNotDeliveredPress}
                style={styles.notDeliveredContainer}
              >
                <View style={styles.notDeliveredBody}>
                  <View style={{ flexDirection: "row" }}>
                    <Image
                      resizeMode="contain"
                      style={styles.notDeliveredIcon}
                      source={{
                        uri: "https://public-cdn.citymall.live/cm-admin-storage-public/ss%2F1681745664208-CX%20RTO.png",
                      }}
                    />
                    <View style={styles.notDeliveredTextContainer}>
                      <Text style={styles.notDeliveredTitle}>
                        {getUnableToDeliverText(
                          deliveryDetails?.unableToDeliver,
                        )}
                      </Text>
                      <Text style={styles.notDeliveredCustomer}>
                        {t(`${DELIVERY_PATH}/customerEffect`, {
                          count: deliveryDetails?.usersUnableToDeliver,
                        })}
                      </Text>
                    </View>
                  </View>
                  <RightArrow
                    stroke={colors.extraLightBlack}
                    fill={colors.extraLightBlack}
                    style={styles.notDeliveredRightIcon}
                  />
                </View>
                <Text style={styles.notDeliveredDescription}>
                  {t(`${DELIVERY_PATH}/viewDetailsToTake`)}
                </Text>
              </TouchableOpacity>
            ) : null}
          </View>
        ) : null}
        <CratePacketItemsInfo Content={Content} onPressInfo={onPressInfo} />
        <View style={styles.buttonStyle}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            {features?.previous_delivered_amount ? (
              <>
                <Rupees
                  bgColor="#00AB59"
                  bgOpacity={1}
                  color="rgba(255, 255, 255, 1)"
                  width={20}
                  height={20}
                />
                <CustomText
                  variant="body_text_3"
                  style={{
                    color: color.lightBlack,
                    marginLeft: 8,
                    marginRight: 4,
                  }}
                >
                  कैश पेमेंट :
                </CustomText>
                <CustomText variant="title_16">{`${t(
                  `${PATH}/rs`,
                )} ${totalPayableAmount}`}</CustomText>
              </>
            ) : null}
          </View>
          <TouchableNativeFeedback
            testID="handlePressViewDetails"
            background={TouchableNativeFeedback.Ripple("rgba(0, 0, 0, 0.05)")}
            onPress={handlePressViewDetails}
          >
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Text style={styles.viewDetailsText}>
                {t(`${PATH}/viewDetails`)}
              </Text>
              <RightArrow
                stroke={colors.extraLightBlack}
                fill={colors.extraLightBlack}
              />
            </View>
          </TouchableNativeFeedback>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  cardContainer: {
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  card: {
    backgroundColor: colors.white,
    borderWidth: 0.5,
    borderRadius: 10,
    elevation: 2,
    borderColor: colors.lighterBlack,
  },
  headerContainer: {
    padding: 10,
    flexDirection: "row",
    alignItems: "center",
  },
  greenHeaderText: {
    fontSize: 12,
    fontFamily: "NotoSansDevanagari-Bold",
    lineHeight: 18,
    color: colors.plain_green,
    marginHorizontal: 4,
  },
  greyHeaderText: {
    fontSize: 12,
    fontFamily: "NotoSansDevanagari-Bold",
    lineHeight: 18,
    color: colors.lightBlack,
    alignItems: "center",
    marginHorizontal: 4,
  },
  detailsOuterCard: {
    flexDirection: "row",
    paddingVertical: 16,
    paddingRight: 12,
  },
  detailsInnercard: {
    flexDirection: "row",
    justifyContent: "center",
  },
  cardCount: {
    marginTop: 3,
    fontSize: 16,
    lineHeight: 24,
    fontFamily: "NotoSansDevanagari-Bold",
  },
  buttonStyle: {
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderTopWidth: 0.8,
    borderColor: colors.lighterBlack,
    width: "100%",
  },
  detailsCard: {
    flexDirection: "row",
    justifyContent: "space-around",
    flex: 1,
    alignItems: "center",
  },
  separator: {
    width: 1,
    height: 24,
    backgroundColor: colors.lighterBlack,
  },
  viewDetailsText: {
    fontFamily: "NotoSansDevanagari-Bold",
    fontSize: 14,
    lineHeight: 20,
    marginRight: 8,
  },
  contentContainer: {
    marginHorizontal: 6,
  },
  notDeliveredContainer: {
    borderColor: "rgba(255, 46, 0, 0.2)",
    backgroundColor: "#FFEEEB",
    margin: 12,
    borderRadius: 8,
    borderWidth: 1,
    paddingHorizontal: 12,
    paddingTop: 11,
    paddingBottom: 8,
  },
  notDeliveredIcon: {
    width: 38,
    height: 35,
    marginTop: 2,
  },
  notDeliveredTextContainer: {
    marginStart: 12,
  },
  notDeliveredRightIcon: {
    alignSelf: "center",
  },
  notDeliveredTitle: {
    fontSize: 14,
    fontFamily: fontFamily.bold,
    color: colors.plain_red,
  },
  notDeliveredDescription: {
    fontSize: 12,
    fontFamily: fontFamily.regular,
    color: colors.mediumBlack,
  },
  notDeliveredCustomer: {
    fontSize: 14,
    fontFamily: fontFamily.semiBold,
    color: colors.mediumBlack,
  },
  notDeliveredBody: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
  },
});

export default DeliveryCard;
